import { createContext, useContext, useState } from "react";

const TourContext = createContext({ open: false, setOpen: () => {} });

export function TourProvider({ children }) {
  const [open, setOpen] = useState(false);
  return <TourContext.Provider value={{ open, setOpen }}>{children}</TourContext.Provider>;
}

export const useTour = () => useContext(TourContext);
